<template>
    <div class="c-o-table">
        <table class="c-o-table__table">
            <thead class="c-o-table__thead">
                <tr v-if="isDesktop" class="c-o-table__tr">
                    <th class="c-o-table__th">Förfrågan</th>
                    <th class="c-o-table__th">Datum</th>
                    <th class="c-o-table__th">Typ</th>
                    <th class="c-o-table__th">Omdöme</th>
                    <th class="c-o-table__th">Besvarade</th>
                    <th class="c-o-table__th"></th>
                </tr>
                <tr v-else class="c-o-table__tr">
                    <th class="c-o-table__th" :colspan="colspanAll">Förfrågningar</th>
                </tr>
            </thead>
            <tbody class="c-o-table__tbody" v-if="requests.length > 0">
                <table-row
                    v-for="request in requests"
                    :request="request"
                    :key="`request-${request.Id}`"
                    @toggleStatus="$emit('toggleStatus', $event)"
                ></table-row>
            </tbody>
            <tbody class="c-o-table__tbody" v-else>
                <tr class="c-o-table__tr">
                    <td class="c-o-table__td" :colspan="colspanAll">
                        <empty-state v-bind="emptyState"></empty-state>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import TableRow from '../molecules/MoleculeRequestsListCustomerTableRow.vue'
    import EmptyState from '../molecules/MoleculeEmptyState.vue';

    export default {
        props: {
            requests: {
                default: () => {
                    return []
                },
                type: Array
            },
            emptyState: {
                default: ()=>({
                    body: '<p>Det finns inga förfrågningar att visa här än.</p>',
                    icon: ''
                }),
                type: Object
            }
        },
        components: {
            TableRow,
            EmptyState
        },
        data() {
            return {
                colspanAll: 5
            }
        },
        computed: {
            isDesktop: function() {
                return this.$mq === 'medium' || this.$mq === 'large' || this.$mq === 'xLarge' ? true : false
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/OrganismRequestsListCustomerTable.vue